import axios from "axios";
import type {
  CreateMeetingRequest,
  CreateMeetingResponse,
  JoinMeetingRequest,
  JoinMeetingResponse,
  EndMeetingRequest,
  EndMeetingResponse,
  RecordingRequest,
  RecordingResponse,
} from "../types/video";

const REACT_APP_BACKEND_EVENT_URL = process.env.REACT_APP_BACKEND_EVENT_URL;
const VIDEO_PROTOCOL_VERSION = 2;
const VIDEO_API_PATH = `${REACT_APP_BACKEND_EVENT_URL}/video/v2`;

const assertProtocol = <T extends { protocolVersion: number }>(data: T): T => {
  if (data.protocolVersion !== VIDEO_PROTOCOL_VERSION) {
    throw new Error("視訊服務版本不相容，請重新開啟頁面");
  }
  return data;
};

/**
 * Create a new video meeting
 * POST /video/v2/create
 */
export const createMeeting = async (
  data: CreateMeetingRequest,
): Promise<CreateMeetingResponse> => {
  const response = await axios.post(`${VIDEO_API_PATH}/create`, {
    ...data,
    protocolVersion: VIDEO_PROTOCOL_VERSION,
  });
  return assertProtocol(response.data);
};

/**
 * Join an existing video meeting
 * POST /video/v2/join
 */
export const joinMeeting = async (
  data: JoinMeetingRequest,
): Promise<JoinMeetingResponse> => {
  const response = await axios.post(`${VIDEO_API_PATH}/join`, {
    ...data,
    protocolVersion: VIDEO_PROTOCOL_VERSION,
  });
  return assertProtocol(response.data);
};

/**
 * End a video meeting
 * POST /video/v2/end
 */
export const endMeeting = async (
  data: EndMeetingRequest,
): Promise<EndMeetingResponse> => {
  const response = await axios.post(`${VIDEO_API_PATH}/end`, {
    ...data,
    protocolVersion: VIDEO_PROTOCOL_VERSION,
  }, { timeout: 15_000 });
  return assertProtocol(response.data);
};

export const startRecording = async (
  data: RecordingRequest,
): Promise<RecordingResponse> => {
  const response = await axios.post(`${VIDEO_API_PATH}/recording/start`, {
    ...data,
    protocolVersion: VIDEO_PROTOCOL_VERSION,
  });
  return assertProtocol(response.data);
};
